const data = {
  bannerData: {
    title: '腾讯云架构图素材库',
    des: '提供构建腾讯云架构图所需的资源包、产品与服务图标集和在线制作工具。',
  },
  MtCaseCardData: [
    {
      href: 'https://cloud.tencent.com/product/advisor',
      title: '腾讯云顾问',
      img: 'https://dscache.tencent-cloud.cn/upload/uploader/Group 1000004542-4db21c56abba0219b03b6cadd5ba7fdd12fd8542.svg',
      desc: '云顾问（Tencent Cloud Smart Advisor）是一款提供可视化云架构IDE和多个ITOM领域垂直应用的云上治理平台，以“一个平台，多个应用”为产品理念，依托腾讯云海量运维专家经验，助您打造卓越架构，实现便捷、灵活的一站式云上治理。'
    },
    {
      href: 'https://docs.qq.com/mall/index/flowchart?from_page=cloud_diagram_material',
      title: '腾讯文档',
      img: 'https://dscache.tencent-cloud.cn/upload/uploader/1-adbdd846c672dcfa7a67b45141a81e11cac69966.png',
    },
    {
      href: 'https://www.processon.com/',
      title: 'ProcessOn',
      img: 'https://imgcache.qq.com/operation/dianshi/other/20211220-icon-po.59d9a0f1413f215fe03a6235767ac5bbe5446a67.svg',
    },
    {
      href: 'https://www.edrawmax.cn/',
      title: '亿图图示',
      img: 'https://imgcache.qq.com/operation/dianshi/other/20211206-icon-yitu.4d650fb0e0b15f88965065dd2fbbdeb1f5e83367.png',
    },
  ],
  MdComplexData: {
    content: {
      img: 'https://imgcache.qq.com/operation/dianshi/other/202112-img.87ab85689990ddc7092c63280217810b3f224586.svg',
      title: '资源包',
      desc: '包含腾讯云产品与服务官方图标集。除了提供基础的PNG、SVG格式资源包之外，我们还提供了便于客户直接使用的PPT格式，可以轻松的粘贴到您的文件中。我们将持续补充更多的格式。',
      // link: (
      //   <CtLink
      //     type="arrow"
      //     to="https://cloud.tencent.com/"
      //     text="了解使用规则"
      //   />
      // ),
    },
    media: [
      {
        href: 'https://dscache.tencent-cloud.cn/upload/uploader/tencent_cloud_product_icons_png-07b5ef3f37c0b972d8cfe9f54b0bc035b06a49b3.zip',
        title: 'PNG格式',
        desc: 'TencentCloud_icons_png.zip',
        img: 'https://imgcache.qq.com/qcloud/tcloud_dtc/static/static_source_business/ee3a3909-3d70-40b1-9d41-355fdc03b4bd.svg',
      },
      {
        href: 'https://dscache.tencent-cloud.cn/upload/uploader/tencent_cloud_product_icons_svg-cabb63b49a754a7417b973bec8724623f0414854.zip',
        title: 'SVG格式',
        desc: 'TencentCloud_icons_svg.zip',
        img: 'https://imgcache.qq.com/qcloud/tcloud_dtc/static/static_source_business/ee3a3909-3d70-40b1-9d41-355fdc03b4bd.svg',
      },
      {
        href: 'https://dscache.tencent-cloud.cn/upload/uploader/tencent_cloud_product_icons_pptx-c94a46b7ed10d292445dbe22eb19ceebe5a41650.zip',
        title: 'PPT 格式',
        desc: 'TencentCloud_icons.pptx',
        img: 'https://imgcache.qq.com/qcloud/tcloud_dtc/static/static_source_business/9e76ddee-b692-4571-b45a-41546bfbcf61.svg',
      },
      // {
      //   href: '#',
      //   title: 'Sketch 格式',
      //   desc: 'TencentCloud_icons.sketch',
      //   img: sketch,
      // },
      // {
      //   href: '#',
      //   title: 'Figma 格式',
      //   desc: 'TencentCloud_icons.fg',
      //   img: figma,
      // },
    ],
  },
  actionPanel: {
    title:
      '腾讯云致力于以最 “绿色节能” 的方式让每一位上云的客户，成为全球绿色节能，降低碳排放的的贡献者',
    links: [
      {
        text: '了解更多',
        to: 'https://cloud.tencent.com/act/event/sustainability',
        type: 'hole',
      },
    ],
  },
};
export default data;
